import React, { useEffect, useState } from "react";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import "bootstrap/dist/css/bootstrap.min.css";

const TransferMembers = () => {
  const db = getFirestore();

  const [groups, setGroups] = useState([]);
  const [sourceGroupId, setSourceGroupId] = useState("");
  const [targetGroupId, setTargetGroupId] = useState("");
  const [sourceGroup, setSourceGroup] = useState(null);
  const [targetGroup, setTargetGroup] = useState(null);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [transferredMembers, setTransferredMembers] = useState([]);

  //   useEffect(() => {
  //     const fetchGroups = async () => {
  //       const snapshot = await getDocs(collection(db, "sevakGroups"));
  //       const groupList = snapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data(),
  //       }));
  //       setGroups(groupList);
  //     };
  //     fetchGroups();
  //   }, []);
  useEffect(() => {
    const fetchGroups = async () => {
      const snapshot = await getDocs(collection(db, "sevakGroups"));
      const groupList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log("Fetched groups:", groupList); // Add this line
      setGroups(groupList);
    };
    fetchGroups();
  }, []);

  const fetchGroupDetails = async (groupId, setGroup) => {
    const docRef = doc(db, "sevakGroups", groupId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const groupData = { id: docSnap.id, ...docSnap.data() };
      setGroup(groupData);
    }
  };

  useEffect(() => {
    if (sourceGroupId) fetchGroupDetails(sourceGroupId, setSourceGroup);
  }, [sourceGroupId]);

  useEffect(() => {
    if (targetGroupId) fetchGroupDetails(targetGroupId, setTargetGroup);
  }, [targetGroupId]);

  const handleCheckboxChange = (member) => {
    setSelectedMembers((prev) =>
      prev.some((m) => m.accountId === member.accountId)
        ? prev.filter((m) => m.accountId !== member.accountId)
        : [...prev, member]
    );
  };

  const handleTransfer = () => {
    if (!targetGroupId) {
      alert("Please select a destination group before transferring.");
      return;
    }

    if (selectedMembers.length === 0) return;

    const updatedSourceMembers = sourceGroup.members.filter(
      (member) =>
        !selectedMembers.some((sel) => sel.accountId === member.accountId)
    );

    const updatedTargetMembers = [
      ...(targetGroup.members || []),
      ...selectedMembers,
    ];

    setSourceGroup((prev) => ({
      ...prev,
      members: updatedSourceMembers,
    }));

    setTargetGroup((prev) => ({
      ...prev,
      members: updatedTargetMembers,
    }));

    setTransferredMembers(selectedMembers);
    setSelectedMembers([]);
  };

  //   const handleTransfer = () => {
  //     if (selectedMembers.length === 0) return;

  //     // Remove selected members from source group
  //     const updatedSourceMembers = sourceGroup.members.filter(
  //       (member) =>
  //         !selectedMembers.some((sel) => sel.accountId === member.accountId)
  //     );

  //     // Add selected members to target group
  //     const updatedTargetMembers = [
  //       ...(targetGroup.members || []),
  //       ...selectedMembers,
  //     ];

  //     // Update state
  //     setSourceGroup((prev) => ({
  //       ...prev,
  //       members: updatedSourceMembers,
  //     }));

  //     setTargetGroup((prev) => ({
  //       ...prev,
  //       members: updatedTargetMembers,
  //     }));

  //     // Store transferred members for potential rollback
  //     setTransferredMembers(selectedMembers);

  //     // Clear selection
  //     setSelectedMembers([]);
  //   };

  const handleSourceGroupChange = (groupId) => {
    if (groupId === targetGroupId) {
      setTargetGroupId("");
      setTargetGroup(null);
    }
    setSourceGroupId(groupId);
  };

  const handleTargetGroupChange = (groupId) => {
    if (groupId === sourceGroupId) {
      setSourceGroupId("");
      setSourceGroup(null);
    }
    setTargetGroupId(groupId);
  };

  const handleReturn = () => {
    setSourceGroup((prev) => ({
      ...prev,
      members: [...prev.members, ...transferredMembers],
    }));
    setTargetGroup((prev) => ({
      ...prev,
      members: prev.members.filter(
        (m) => !transferredMembers.some((tm) => tm.id === m.id)
      ),
    }));
    setTransferredMembers([]);
  };

  const handleConfirm = async () => {
    try {
      await updateDoc(doc(db, "sevakGroups", sourceGroupId), {
        members: sourceGroup.members,
      });
      await updateDoc(doc(db, "sevakGroups", targetGroupId), {
        members: targetGroup.members,
      });
      alert("Members transferred successfully!");
      setTransferredMembers([]);
    } catch (error) {
      console.error("Error confirming transfer:", error);
    }
  };

  const renderGroupDetails = (group) => (
    <div className="mb-2">
      <strong>Account ID:</strong> {group.accountId} <br />
      <strong>Name:</strong> {group.groupName} <br />
      <strong>Station:</strong> {group.location}
    </div>
  );

  const renderMembersTable = (members = [], selectable = false) => {
    if (!Array.isArray(members) || members.length === 0) {
      console.log("Rendering members:", members);
      // Debug log to check if members is an array and its length
      return <div className="text-muted">No members found.</div>;
    }

    console.log("Rendering members:", members); // Debug log

    return (
      <table className="table table-bordered table-sm">
        <thead className="table-light">
          <tr>
            {selectable && <th>Select</th>}
            <th>Account ID</th>
            <th>Sevak Name</th>
            <th>Station</th>
            <th>Aadhar Number</th>
            <th>Mobile Number</th>
          </tr>
        </thead>
        <tbody>
          {members.map((member, idx) => (
            <tr key={idx}>
              {selectable && (
                <td>
                  <input
                    type="checkbox"
                    checked={selectedMembers.some(
                      (m) => m.accountId === member.accountId
                    )}
                    onChange={() => handleCheckboxChange(member)}
                  />
                </td>
              )}
              <td>{member.accountId}</td>
              <td>{member.sevakName}</td>
              <td>{member.station}</td>
              <td>{member.AdharNumber}</td>
              <td>{member.mobileNo}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-4">Transfer Members Between Groups</h4>

      <div className="row mb-4">
        <div className="col-md-6">
          <label className="form-label">Source Group</label>

          {/* <select
            className="form-select"
            onChange={(e) => setSourceGroupId(e.target.value)}
            value={sourceGroupId}
          >
            <option value="">Select Source Group</option>{" "}
            {groups.map((group, index) => (
              <option key={index} value={group.id}>
                {group.groupName || group.accountId || `Group ${index + 1}`}{" "}
              </option>
            ))}
          </select> */}

          <select
            className="form-select"
            onChange={(e) => handleSourceGroupChange(e.target.value)}
            value={sourceGroupId}
          >
            <option value="">Select Source Group</option>{" "}
            {groups
              .filter((group) => group.id !== targetGroupId)
              .map((group) => (
                <option key={group.id} value={group.id}>
                  {group.groupName}
                </option>
              ))}
          </select>

          {sourceGroup && renderGroupDetails(sourceGroup)}
          {sourceGroup && renderMembersTable(sourceGroup.members || [], true)}
        </div>

        <div className="col-md-6">
          <label className="form-label">Target Group</label>

          <select
            className="form-select"
            onChange={(e) => handleTargetGroupChange(e.target.value)}
            value={targetGroupId}
          >
            <option value="">Select Target Group</option>{" "}
            {groups
              .filter((group) => group.id !== sourceGroupId)
              .map((group) => (
                <option key={group.id} value={group.id}>
                  {group.groupName}
                </option>
              ))}
          </select>

          {targetGroup && renderGroupDetails(targetGroup)}
          {targetGroup && renderMembersTable(targetGroup.members || [])}
        </div>
      </div>

      <div className="d-flex gap-3">
        <button
          className="btn btn-primary"
          onClick={handleTransfer}
          disabled={selectedMembers.length === 0}
        >
          Transfer Selected
        </button>
        <button
          className="btn btn-warning"
          onClick={handleReturn}
          disabled={transferredMembers.length === 0}
        >
          Return Back
        </button>
        <button
          className="btn btn-success"
          onClick={handleConfirm}
          disabled={transferredMembers.length === 0}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default TransferMembers;
